module.exports = __webpack_public_path__ + "img/thumb_23.3e520725.jpg";